import axios from "./axios-config";

export const getAllBlogs = async (keyword, page) => {

    let { data } = await axios.get(`/super-admin/blogs?keywords=${keyword ?? ""}&page=${page}`)
    return (data);

}

export const getSingleBlog = async (id) => {

    let { data } = await axios.get(`/super-admin/blogs/` + id)
    return data;

}
export const deleteSingleBlog = async (id) => {
    let { data } = await axios.delete(`/super-admin/blogs/` + id)
    return data;
}

export const updateSingleBlogs = async (updateData) => {

    let { data } = await axios.post(`/super-admin/blogs/${updateData.id}?_method=put`, updateData.data)
    return data;
}

export const storeSingleBlogs = async (storeData) => {

    let { data } = await axios.post(`/super-admin/blogs`, storeData)
    return data
}


// export const getBlogBlogs = async (data) => {
//     let { data } =  await axios.post(`/super-admin/Blogs/all/blogs`, data)
//     return data;
// }

export const getWorkshopBlogs = async (data) => {
    try {
        let response = await axios.post(`/super-admin/Blogs/all/workshops`, data)
        return (response.data);
    } catch (error) {
        return (error);
    }
}

